import * as d3 from 'd3';

/* eslint-disable @typescript-eslint/naming-convention */
export default class D3Wrapper {

  static setupBarChart(htmlElement, response) {
    // clear the old elements
    d3.select(htmlElement).selectAll("*").remove();

    // set the dimensions and margins of the graph
    const margin = { top: 20, right: 40, bottom: 40, left: 40 };
    // to make graph responsive calcuate we set width 100%
    // append the svg object to the body of the page
    const svg = d3.select(htmlElement)
      .append("svg")
      .attr("width", "100%")
      .attr("height", "300")
      .append("g")
      .attr("transform", `translate(${margin.left}, ${margin.top})`);

    const width = document.getElementById(htmlElement.substring(1)).offsetWidth - margin.left - margin.right;
    const height = 300 - margin.top - margin.bottom;

    // X axis
    const x = d3.scaleBand()
      .range([0, width])
      .domain(response.map(d => d.label))
      .padding(0.2);
    svg.append("g")
      .attr("class", "xAxis")
      .attr("transform", `translate(0, ${height})`)
      .call(d3.axisBottom(x))
      .selectAll("text");

    // Add Y axis
    const y = d3.scaleLinear()
      .domain([0, d3.max(response, (d: any) => d.data) + 2] as any)
      .range([height, 0]);

    const yAxis = d3.axisLeft(y)
      .ticks((d3.max(response, (d: any) => d.data) as any > 10) ? 10 : d3.max(response, (d: any) => d.data) + 2, "f");
    svg.append("g")
      .attr("class", "yAxis")
      .call(yAxis);

    // add grid lines
    d3.selectAll("g.yAxis g.tick")
      .append("line")
      .attr("class", "gridline")
      .attr("x1", 0)
      .attr("y1", 0)
      .attr("x2", width)
      .attr("y2", 0);

    d3.selectAll("g.xAxis g.tick")
      .append("line")
      .attr("class", "gridline")
      .attr("x1", 0)
      .attr("y1", -height)
      .attr("x2", 0)
      .attr("y2", 0);

    // create tooltip element
    const tooltip = d3.select(htmlElement)
      .append("div")
      .attr("class", "tooltip")
      .style("opacity", 0)
      .style("position", "absolute")
      .style("background-color", "white")
      .style("border", "solid")
      .style("border-color", "#888888")
      .style("border-width", "2px")
      .style("border-radius", "5px")
      .style("padding", "5px");

    // Bars
    const rect = svg.selectAll("mybar")
      .data(response)
      .join("rect")
      .attr("x", (d: any) => x(d.label))
      .attr("width", x.bandwidth())
      // no bar at the beginning thus:
      .attr("height", d => height - y(0)) // always equal to 0
      .attr("y", d => y(0))
      .attr("fill", "#9b9fb8")
      .on("mouseover", function (event, d: any) {
        tooltip.html(`Count: ${d.data}`).style("opacity", 1);
        d3.select(this)
          .transition()
          .duration(200)
          .attr("fill", "#5864a8");
      })
      .on("mousemove", function (event, d) {
        tooltip
          .style("top", (d3.pointer(event)[1] + 20) + "px")
          .style("left", (d3.pointer(event)[0]) + "px");
      })
      .on("mouseout", function () {
        tooltip.html(``).style("opacity", 0);
        d3.select(this)
          .transition()
          .duration(200)
          .attr("fill", "#9b9fb8");
      });

    // Transition Animation
    svg.selectAll("rect")
      .transition()
      .ease(d3.easeLinear)
      .duration(500)
      .attr("y", (d: any) => y(d.data))
      .attr("height", (d: any) => height - y(d.data));
  };

  static setupRatioBarChart(htmlElement, response, rotateXLabels = false) {
    // clear the old elements
    d3.select(htmlElement).selectAll("*").remove();

    // set the dimensions and margins of the graph
    const margin = { top: 20, right: 40, bottom: 40, left: 40 };
    if (rotateXLabels) {
      margin.bottom = 60;
    }

    // to make graph responsive calcuate we set width 100%
    // append the svg object to the body of the page
    const svg = d3.select(htmlElement)
      .append("svg")
      .attr("width", "100%")
      .attr("height", "280")
      .append("g")
      .attr("transform", `translate(${margin.left}, ${margin.top})`);
    const width = document.getElementById(htmlElement.substring(1)).offsetWidth - margin.left - margin.right;
    const height = 280 - margin.top - margin.bottom;

    // X axis
    const x = d3.scaleBand()
      .range([0, width])
      .domain(response.map(d => d.label))
      .padding(0.5);

    if (rotateXLabels) {
      svg.append("g")
        .attr("transform", `translate(0, ${height})`)
        .call(d3.axisBottom(x))
        .selectAll("text")
        .style("text-anchor", "end")
        .attr("dx", "-.8em")
        .attr("dy", ".15em")
        .attr("transform", "rotate(-45)");
    } else {
      svg.append("g")
        .attr("transform", `translate(0, ${height})`)
        .call(d3.axisBottom(x))
        .selectAll("text");
    }

    // Add Y axis
    const y = d3.scaleLinear()
      .domain([0, 100] as any)
      .range([height, 0]);

    const yAxis = d3.axisLeft(y)
      .ticks(10, "f");
    svg.append("g")
      .call(yAxis);


    // create tooltip element
    const tooltip = d3.select(htmlElement)
      .append("div")
      .attr("class", "tooltip")
      .style("opacity", 0)
      .style("position", "absolute")
      .style("background-color", "white")
      .style("border", "solid")
      .style("border-color", "#888888")
      .style("border-width", "2px")
      .style("border-radius", "5px")
      .style("padding", "5px");

    // Bars
    const rect = svg.selectAll("mybar")
      .data(response)
      .join("rect")
      .attr("x", (d: any) => x(d.label))
      .attr("width", x.bandwidth())
      // no bar at the beginning thus:
      .attr("height", d => height - y(0)) // always equal to 0
      .attr("y", d => y(0))
      .attr("fill", "#9b9fb8")
      .on("mouseover", function (event, d: any) {
        tooltip.html(`Percent: ${d.data}`).style("opacity", 1);
        d3.select(this)
          .transition()
          .duration(200)
          .attr("fill", "#5864a8");
      })
      .on("mousemove", function (event, d) {
        tooltip
          .style("top", (d3.pointer(event)[1] + 20) + "px")
          .style("left", (d3.pointer(event)[0]) + "px");
      })
      .on("mouseout", function () {
        tooltip.html(``).style("opacity", 0);
        d3.select(this)
          .transition()
          .duration(200)
          .attr("fill", "#9b9fb8");
      });

    // Transition Animation
    svg.selectAll("rect")
      .transition()
      .ease(d3.easeLinear)
      .duration(500)
      .attr("y", (d: any) => y(d.data))
      .attr("height", (d: any) => height - y(d.data));
  };

  static setupStackedBarChart(htmlElement, subgroups, response) {
    // clear the old elements
    d3.select(htmlElement).selectAll("*").remove();

    // set the dimensions and margins of the graph
    const margin = { top: 20, right: 40, bottom: 60, left: 40 };
    // to make graph responsive calcuate we set width 100%
    // append the svg object to the body of the page
    const svg = d3.select(htmlElement)
      .append("svg")
      .attr("width", "100%")
      .attr("height", "300")
      .append("g")
      .attr("transform", `translate(${margin.left}, ${margin.top})`);

    const width = document.getElementById(htmlElement.substring(1)).offsetWidth - margin.left - margin.right;
    const height = 300 - margin.top - margin.bottom;

    // X axis
    const x = d3.scaleBand()
      .range([0, width])
      .domain(response.map(d => d.label))
      .padding(0.2);
    svg.append("g")
      .attr("class", "xAxis")
      .attr("transform", `translate(0, ${height})`)
      .call(d3.axisBottom(x))
      .selectAll("text");

    // Add Y axis
    const y = d3.scaleLinear()
      .domain([0, d3.max(response, (d: any) => d[subgroups[0]]) + 2] as any)
      .range([height, 0]);

    const yAxis = d3.axisLeft(y)
      .ticks((d3.max(response, (d: any) => d[subgroups[0]]) as any > 10) ? 10 : d3.max(response, (d: any) => d[subgroups[0]]) + 2, "f");
    svg.append("g")
      .attr("class", "yAxis")
      .call(yAxis);

    // add grid lines
    d3.selectAll("g.yAxis g.tick")
      .append("line")
      .attr("class", "gridline")
      .attr("x1", 0)
      .attr("y1", 0)
      .attr("x2", width)
      .attr("y2", 0);

    d3.selectAll("g.xAxis g.tick")
      .append("line")
      .attr("class", "gridline")
      .attr("x1", 0)
      .attr("y1", -height)
      .attr("x2", 0)
      .attr("y2", 0);

    // color palette = one color per subgroup
    const colors = ["#9b9fb8", "#f3a4be"];
    const color = d3.scaleOrdinal()
      .domain(subgroups)
      .range(colors);

    // stack the data? --> stack per subgroup
    const stackedData = d3.stack()
      .keys(subgroups)
      (response);

    // ----------------
    // Create a tooltip
    // ----------------
    const tooltip = d3.select(htmlElement)
      .append("div")
      .attr("class", "tooltip")
      .style("opacity", 0)
      .style("position", "absolute")
      .style("background-color", "white")
      .style("border", "solid")
      .style("border-color", "#888888")
      .style("border-width", "2px")
      .style("border-radius", "5px")
      .style("padding", "5px");

    // Three function that change the tooltip when user hover / move / leave a cell
    const mouseover = function (event, d) {
      const subgroupName = (d3.select(this.parentNode).datum() as any).key;
      const subgroupValue = d.data[subgroupName];

      tooltip.html(`${subgroupName}: ${subgroupValue}`).style("opacity", 1);
      d3.select(this)
        .transition()
        .duration(200)
        .attr("fill", (subgroupName === subgroups[0]) ? "#5864a8" : "#f87ca5");

    };
    const mousemove = function (event, d) {
      tooltip
        .style("top", (d3.pointer(event)[1] + 20) + "px")
        .style("left", (d3.pointer(event)[0]) + "px");
    };
    const mouseleave = function (event, d) {
      const subgroupName = (d3.select(this.parentNode).datum() as any).key;

      tooltip.html(``).style("opacity", 0);
      d3.select(this)
        .transition()
        .duration(200)
        .attr("fill", (subgroupName === subgroups[0]) ? "#9b9fb8" : "#f3a4be");
    };

    // Show the bars
    console.log(stackedData);
    svg.append("g")
      .selectAll("g")
      // Enter in the stack data = loop key per key = group per group
      .data(stackedData)
      .join("g")
      .attr("fill", (d: any) => (color(d.key) as any))
      .selectAll("rect")
      // enter a second time = loop subgroup per subgroup to add all rectangles
      .data(d => d)
      .join("rect")
      .attr("x", (d: any) => x(d.data.label))
      .attr("y", d => y(d[1] - d[0]))
      .attr("height", d => y(d[0]) - y(d[1]))
      .attr("width", x.bandwidth())
      .on("mouseover", mouseover)
      .on("mousemove", mousemove)
      .on("mouseleave", mouseleave);

    const legendTranslateX = (width / 2) - (((subgroups[0].length * 8) + (18 + subgroups[1].length * 8)) / 2);
    const legend = svg.append('g')
      .attr('class', 'legend')
      .attr('transform', 'translate(' + legendTranslateX + ', ' + (height + (margin.bottom / 2)) + ')');

    legend.selectAll('rect')
      .data(subgroups)
      .enter()
      .append('rect')
      .attr('x', function (d, i) {
        return (i === 0) ? 0 : subgroups[i].length * 8;
      })
      .attr('y', 0)
      .attr('width', 12)
      .attr('height', 12)
      .attr('fill', function (d, i) {
        return colors[i];
      });

    legend.selectAll('text')
      .data(subgroups as string[])
      .enter()
      .append('text')
      .text(function (d) {
        return d;
      })
      .attr('x', function (d, i) {
        return (i === 0) ? 18 : 18 + subgroups[i].length * 8;
      })
      .attr('y', 0)
      .style("font-size", "0.8em")
      .attr('text-anchor', 'start')
      .attr('alignment-baseline', 'hanging');

  };

  static setupHorizontalStackedBarChart(htmlElement, subgroups, response) {
    // clear the old elements
    d3.select(htmlElement).selectAll("*").remove();

    const width = document.getElementById(htmlElement.substring(1)).offsetWidth;
    const height = 30;

    // to make graph responsive calcuate we set width 100%
    // append the svg object to the body of the page
    const svg = d3.select(htmlElement)
      .append("svg")
      .attr("width", "100%")
      .attr("height", height)
      .append("g");

    // X axis
    const x = d3.scaleLinear()
      .range([0, width])
      .domain([0, 100]);

    // Add Y axis
    const y = d3.scaleLinear()
      .domain(["wasHelpful"] as any)
      .range([height, 0]);

    // color palette = one color per subgroup
    let colors = null, colorsOnHover = null;
    if (subgroups.length === 5) {
      colors = ["#81c784", "#a5d6a7", "#cfd8dc", "#ef9a9a", "#e57373"];
      colorsOnHover = ["#519657", "#75a478", "#9ea7aa", "#ba6b6c", "#af4448"];
    } else if (subgroups.length === 2) {
      colors = ["#81a3c7", "#e69d61"];
      colorsOnHover = ["#558dc8", "#d07c37"];
    }

    const color = d3.scaleOrdinal()
      .domain(subgroups)
      .range(colors);

    // stack the data? --> stack per subgroup
    const stackedData = d3.stack()
      .keys(subgroups)
      (response);

    // ----------------
    // Create a tooltip
    // ----------------
    const tooltip = d3.select(htmlElement)
      .append("div")
      .attr("class", "tooltip")
      .style("opacity", 0)
      .style("position", "absolute")
      .style("background-color", "white")
      .style("border", "solid")
      .style("border-color", "#888888")
      .style("border-width", "2px")
      .style("border-radius", "5px")
      .style("padding", "5px");

    // Three function that change the tooltip when user hover / move / leave a cell
    const mouseover = function (event, d) {
      const subgroupName = (d3.select(this.parentNode).datum() as any).key;
      const subgroupValue = d.data[subgroupName];

      tooltip.html(`${subgroupName}: ${subgroupValue}`).style("opacity", 1);
      d3.select(this)
        .transition()
        .duration(200)
        .attr("fill", () => {
          if (subgroupName === subgroups[0]) return colorsOnHover[0];
          else if (subgroupName === subgroups[1]) return colorsOnHover[1];
          else if (subgroupName === subgroups[2]) return colorsOnHover[2];
          else if (subgroupName === subgroups[3]) return colorsOnHover[3];
          else if (subgroupName === subgroups[4]) return colorsOnHover[4];
        });
    };
    const mousemove = function (event, d) {
      tooltip
        .style("top", (d3.pointer(event)[1] + 20) + "px")
        .style("left", (d3.pointer(event)[0]) + "px");
    };
    const mouseleave = function (event, d) {
      const subgroupName = (d3.select(this.parentNode).datum() as any).key;

      tooltip.html(``).style("opacity", 0);
      d3.select(this)
        .transition()
        .duration(200)
        .attr("fill", () => {
          if (subgroupName === subgroups[0]) return colors[0];
          else if (subgroupName === subgroups[1]) return colors[1];
          else if (subgroupName === subgroups[2]) return colors[2];
          else if (subgroupName === subgroups[3]) return colors[3];
          else if (subgroupName === subgroups[4]) return colors[4];
        });
    };

    // Show the bars
    svg.append("g")
      .selectAll("g")
      // Enter in the stack data = loop key per key = group per group
      .data(stackedData)
      .join("g")
      .attr("fill", (d: any) => (color(d.key) as any))
      .selectAll("rect")
      // enter a second time = loop subgroup per subgroup to add all rectangles
      .data(d => d)
      .join("rect")
      .attr("x", d => x(d[0]))
      .attr("y", d => y(d.data.label))
      .attr("height", height)
      .attr("width", d => x(d[1]) - x(d[0]))
      .on("mouseover", mouseover)
      .on("mousemove", mousemove)
      .on("mouseleave", mouseleave);
  }

  static setupLineChart(htmlElement, response) {
    // clear the old elements
    d3.select(htmlElement).selectAll("*").remove();

    // set the dimensions and margins of the graph
    const margin = { top: 20, right: 40, bottom: 40, left: 40 };
    // to make graph responsive calcuate we set width 100%
    // append the svg object to the body of the page
    const svg = d3.select(htmlElement)
      .append("svg")
      .attr("width", "100%")
      .attr("height", "300")
      .append("g")
      .attr("transform", `translate(${margin.left}, ${margin.top})`);

    const width = document.getElementById(htmlElement.substring(1)).offsetWidth - margin.left - margin.right;
    const height = 300 - margin.top - margin.bottom;

    // X axis
    const x = d3.scalePoint()
      .domain(response.map(d => d.label))
      .range([0, width]);
    svg.append("g")
      .attr("class", "xAxis")
      .attr("transform", `translate(0, ${height})`)
      .call(d3.axisBottom(x))
      .selectAll("text");

    // Add Y axis
    const y = d3.scaleLinear()
      .domain([0, d3.max(response, (d: any) => d.data) + 2] as any)
      .range([height, 0]);

    const yAxis = d3.axisLeft(y)
      .ticks((d3.max(response, (d: any) => d.data) as any > 10) ? 10 : d3.max(response, (d: any) => d.data) + 2, "f");
    svg.append("g")
      .attr("class", "yAxis")
      .call(yAxis);

    // add grid lines
    d3.selectAll("g.yAxis g.tick")
      .append("line")
      .attr("class", "gridline")
      .attr("x1", 0)
      .attr("y1", 0)
      .attr("x2", width)
      .attr("y2", 0);

    d3.selectAll("g.xAxis g.tick")
      .append("line")
      .attr("class", "gridline")
      .attr("x1", 0)
      .attr("y1", -height)
      .attr("x2", 0)
      .attr("y2", 0);

    // create tooltip element
    const tooltip = d3.select(htmlElement)
      .append("div")
      .attr("class", "tooltip")
      .style("opacity", 0)
      .style("position", "absolute")
      .style("background-color", "white")
      .style("border", "solid")
      .style("border-color", "#888888")
      .style("border-width", "2px")
      .style("border-radius", "5px")
      .style("padding", "5px");

    // Add the area
    svg.append("path")
      .datum(response)
      .attr("fill", "#c3c5ce")
      .attr("fill-opacity", 0.8)
      .attr("stroke", "none")
      .attr("d", d3.area()
        .x((d: any) => x(d.label))
        .y0(height)
        .y1((d: any) => y(d.data))
      );

    // Add the line
    svg.append("path")
      .datum(response)
      .attr("fill", "none")
      .attr("stroke", "#9b9fb8")
      .attr("stroke-width", 1.5)
      .attr("d", d3.line()
        .x(function (d: any) {
          return x(d.label);
        })
        .y(function (d: any) {
          return y(d.data);
        })
      );

    // Add the line
    svg.selectAll("myCircles")
      .data(response)
      .join("circle")
      .attr("fill", "rgba(148,159,177,1)")
      .attr("stroke", "#FFF")
      .attr("cx", (d: any) => x(d.label))
      .attr("cy", (d: any) => y(d.data))
      .attr("r", 3)
      .on("mouseover", function (event, d: any) {
        tooltip.html(`Avg Time: ${d.data}`).style("opacity", 1);
        d3.select(this)
          .transition()
          .duration(200)
          .attr("fill", "#FFF")
          .attr("stroke", "rgba(148,159,177,0.8)");
      })
      .on("mousemove", function (event, d) {
        tooltip
          .style("top", (d3.pointer(event)[1] + 20) + "px")
          .style("left", (d3.pointer(event)[0]) + "px");
      })
      .on("mouseout", function () {
        tooltip.html(``).style("opacity", 0);
        d3.select(this)
          .transition()
          .duration(200)
          .attr("fill", "rgba(148,159,177,1)")
          .attr("stroke", "#FFF");
      });
  };
};
